function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgReload = function SvgReload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.004 512.004",
    style: {
      enableBackground: "new 0 0 512.004 512.004"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4899D2"
    },
    d: "M475.211,79.811L386.43,4.996c-9.015-7.581-22.47-6.397-30.051,2.619s-6.397,22.47,2.619,30.051 l44.016,37.408H192.159C125.324,75.148,71.158,129.314,71.083,196.15v38.281c0,11.771,9.551,21.322,21.322,21.322 s21.322-9.551,21.322-21.322v-38.655c0.075-43.293,35.138-78.357,78.432-78.432h210.98l-44.016,37.408 c-9.015,7.581-10.2,21.036-2.619,30.051c7.581,9.015,21.036,10.2,30.051,2.619l88.781-74.816c9.015-7.569,10.2-21.023,2.631-30.038 c-0.798-0.948-1.683-1.833-2.631-2.631L475.211,79.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293C7D"
    },
    d: "M418.975,255.877c-11.771,0-21.322,9.551-21.322,21.322v38.655 c-0.075,43.293-35.138,78.357-78.432,78.432h-210.98l44.016-37.408c10.312-5.698,14.053-18.666,8.354-28.979 c-5.698-10.312-18.666-14.053-28.979-8.354c-2.369,1.309-4.476,3.055-6.185,5.162l-88.781,74.816 c-9.015,7.569-10.2,21.023-2.631,30.038c0.798,0.948,1.683,1.833,2.631,2.631l88.781,74.815c9.015,7.581,22.47,6.397,30.051-2.619 s6.397-22.47-2.619-30.051l-44.016-37.408h210.356c66.835-0.075,121.002-54.241,121.076-121.076V277.2 C440.298,265.416,430.746,255.877,418.975,255.877z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reload.5a441dbd.svg";
export { ForwardRef as ReactComponent };